; (function () {


    var ViewClientRegistrationUrlFomrat1Routes = [
        {
            "name": "View_Client_Registration_details",
            "templateUrl": "<div emr-view-client-registration-popup></div>",
            "RoutingNumber": 1601,
            files: [
                "AngularScripts/ViewClientRegistrationUrlFomrat1/Services/ViewClientRegistrationPopupService.js",
                "AngularScripts/ViewClientRegistrationUrlFomrat1/Directives/ViewClientRegistrationPopupController.js"
            ]
        },
    ];



    angular.module('EMR.ViewClientRegistrationUrlFomrat1Module', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(ViewClientRegistrationUrlFomrat1Routes, $stateProvider);
            }]);
})();